import { adWrap } from "src/tags/ads/index"
import AsyncStorage from "@react-native-async-storage/async-storage"
import { AdTargetingData } from "src/types/ads/AdTargetingData"

const LAST_AD_SHOWN_KEY = "lastInterstitialAdShown"

const getJSTDate = () => {
  const now = new Date()
  const jstOffset = 9 * 60 * 60 * 1000
  return new Date(now.getTime() + jstOffset)
}

const hasShownAdToday = async (): Promise<boolean> => {
  const lastShown = await AsyncStorage.getItem(LAST_AD_SHOWN_KEY)
  if (!lastShown) return false

  const lastDate = new Date(lastShown)
  const now = getJSTDate()

  return (
    lastDate.getFullYear() === now.getFullYear() &&
    lastDate.getMonth() === now.getMonth() &&
    lastDate.getDate() === now.getDate()
  )
}

const recordAdShown = async () => {
  await AsyncStorage.setItem(LAST_AD_SHOWN_KEY, getJSTDate().toISOString())
}

export const InterstitialAd = async (adTargetingData: AdTargetingData) => {
  const alreadyShown = await hasShownAdToday()
  if (alreadyShown) return

  const targetingData = {
    isManager: String(adTargetingData.userAttributes?.isManager ?? false),
    gender: adTargetingData.userAttributes?.gender ?? "",
    job: adTargetingData.userAttributes?.job ?? "",
    school: adTargetingData.userAttributes?.school ?? "",
    Prefecture: adTargetingData.userAttributes?.prefecture ?? "",
    age: adTargetingData.userAttributes?.age ?? "",
    married: adTargetingData.userAttributes?.married ?? "",
    child: adTargetingData.userAttributes?.child ?? "",
    joinedFreeOrg: String(adTargetingData.userAttributes?.joinedFreeOrganization ?? false),
    orgIds: adTargetingData.userAttributes?.organizationIds ?? [],
    orgPrefectures: adTargetingData.userAttributes?.organizationPrefectures ?? [],
    orgCategories: adTargetingData.userAttributes?.organizationCategories ?? [],
    orgSubCategories: adTargetingData.userAttributes?.organizationSubCategories ?? [],
    domain: adTargetingData.userAttributes?.domain ?? "",
    accountId: adTargetingData.userAttributes?.accountId ?? "",
    platform: adTargetingData.demographic?.platform === "ios" ? "iOS" : adTargetingData.demographic?.platform ?? "",
    appVersion: adTargetingData.demographic?.appVersion ?? "",
    model: adTargetingData.demographic?.model ?? "",
  }

  adWrap.setTargeting(targetingData)
  adWrap.InterstitialAd({
    ios: "/13341826/a_rakuraku.ios_Plus_interstitialvideo",
    android: "/13341826/a_rakuraku.and_Plus_interstitialvideo",
  })()

  await recordAdShown()
}
